export default {"src":"/_next/static/media/quit_white.bb9564b5.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};